import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Header({ section = "realEstate" }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [openLang, setOpenLang] = useState(false);
  const [openAccount, setOpenAccount] = useState(false);

const langRef = useRef(null);
const accountRef = useRef(null);

  const { user, logout } = useAuth();

useEffect(() => {
  const handleClickOutside = (e) => {
    if (langRef.current && !langRef.current.contains(e.target)) {
      setOpenLang(false);
    }

    if (accountRef.current && !accountRef.current.contains(e.target)) {
      setOpenAccount(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const handleAddListingClick = () => {
  if (!user) {
    navigate("/signin");
    return;
  }

  if (section === "renovation") {
    navigate("/add-renovation");
    return;
  }

  navigate("/add-listing");
};


  return (
    <header className="header">
      <div className="header-inner">

       <div className="logo" onClick={() => navigate("/")}>
    <img 
    src="/images/foto11.png" 
    alt="logo" 
    className="logo-img"
    />
      </div>

        <div className="header-right">

          <button
            onClick={handleAddListingClick}
             className="header-btn primary"
          >
            {t("header.addListing")}
          </button>


          {/* Language selector */}
          <div className="language-switch"  ref={langRef} style={{ position: "relative" }}>
            <button
              onClick={() => setOpenLang(!openLang)}
              className="header-btn primary"
            >
              🌐 {i18n.language.toUpperCase()}
            </button>

            {openLang && (
              <div
                style={{
                  position: "absolute",
                  top: "110%",
                  right: 0,
                  background: "#fff",
                  color: "#111",
                  borderRadius: 6,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  minWidth: 120,
                  zIndex: 20,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{ padding: 10, cursor: "pointer", borderBottom: "1px solid #eee" }}
                  onClick={() => {
                    i18n.changeLanguage("en");
                    setOpenLang(false);
                  }}
                >
                  {t("languages.english")}
                </div>

                <div
                  style={{ padding: 10, cursor: "pointer" }}
                  onClick={() => {
                    i18n.changeLanguage("ka");
                    setOpenLang(false);
                  }}
                >
                  {t("languages.georgian")}
                </div>
              </div>
            )}
          </div>

          {/* Account */}
          {user ? (
            <div  ref={accountRef} style={{ position: "relative" }}>
              <button
                onClick={() => setOpenAccount(v => !v)}
                className="header-btn primary"
              >
                {t("header.myAccount")}
              </button>

              {openAccount && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "110%",
                    background: "#fff",
                    color: "#111",
                    borderRadius: 6,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    minWidth: 120,
                    zIndex: 20,
                  }}
                >
                  <div
                    style={{ padding: 10, cursor: "pointer" }}
                    onClick={() => {
                      navigate("/my-listings");
                      setOpenAccount(false);
                    }}
                  >
                    {t("header.myListings")}
                  </div>

                  <div
                    style={{ padding: 7, cursor: "pointer" }}
                    onClick={() => {
                      navigate("/my-profile");
                      setOpenAccount(false);
                    }}
                  >
                    {t("header.myProfile")}
                  </div>

        <div
    style={{ padding: 10, cursor: "pointer" }}
    onClick={() => {
    navigate("/favorites"); // ⚠️ IMPORTANT: correct route
    setOpenAccount(false);
     }}
      >
       {t("header.myFavorites")}
         </div>


                  <div
                    style={{
                      padding: 10,
                      cursor: "pointer",
                      color: "#dc2626",
                      borderTop: "1px solid #eee",
                    }}
                    onClick={() => {
                      logout();
                      navigate("/");
                      setOpenAccount(false);
                    }}
                  >
                    {t("header.logout")}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button
              onClick={() => navigate("/signin")}
              className="header-btn success"
            >
              {t("header.signIn")}
            </button>
          )}

            </div>

        </div>

<div className="category-nav">


//RENOVAIBIJO


  </div>

    </header>
  );
}
